"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function mkr(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M5.6685 15.867V9.83325L10.2442 13.2773V15.867H11.4127V13.035C11.4127 12.9294 11.388 12.8252 11.3408 12.7307C11.2935 12.6362 11.225 12.554 11.1405 12.4905L5.59125 8.31375C5.49008 8.23774 5.36974 8.19139 5.24372 8.17989C5.1177 8.16838 4.99096 8.19218 4.8777 8.24862C4.76444 8.30506 4.66912 8.3919 4.60241 8.49944C4.5357 8.60698 4.50024 8.73096 4.5 8.8575V15.867H5.6685ZM18.324 15.867V9.83325L13.7482 13.2773V15.867H12.5798V13.035C12.5798 12.8205 12.6802 12.6188 12.8512 12.4905L18.4012 8.31375C18.5025 8.2377 18.6229 8.19134 18.749 8.17987C18.8751 8.1684 19.0018 8.19226 19.1151 8.24879C19.2284 8.30531 19.3237 8.39227 19.3904 8.49992C19.457 8.60756 19.4924 8.73164 19.4925 8.85825V15.8678H18.324V15.867Z", fill: color }));
}
exports["default"] = mkr;
//# sourceMappingURL=mkr.js.map